import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

export const PhotoLightbox = ({ photos, index, onIndex, onClose }) => {
  const photo = photos[index];
  const nav = 'absolute top-1/2 -translate-y-1/2 p-3 rounded-full bg-white/15 text-white hover:bg-white/30';
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/90 p-4" onClick={onClose}>
      <button type="button" onClick={onClose} aria-label="Close" className="absolute right-4 top-4 p-3 rounded-full bg-white/15 text-white hover:bg-white/30">
        <SafeIcon icon={FiIcons.FiX} />
      </button>
      {index > 0 && (
        <button type="button" aria-label="Previous" className={`${nav} left-3`} onClick={(e) => { e.stopPropagation(); onIndex(index - 1); }}>
          <SafeIcon icon={FiIcons.FiChevronLeft} />
        </button>
      )}
      {photo.url && (
        <img src={photo.url} alt={photo.file_name} className="max-h-full max-w-full object-contain" onClick={(e) => e.stopPropagation()} />
      )}
      {index < photos.length - 1 && (
        <button type="button" aria-label="Next" className={`${nav} right-3`} onClick={(e) => { e.stopPropagation(); onIndex(index + 1); }}>
          <SafeIcon icon={FiIcons.FiChevronRight} />
        </button>
      )}
    </div>
  );
};